import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class InsLoginOtpService {

  private sendOtpUrl = `${GlobalVariable.BASE_API_URL_SPARES}/insurancelogin/v2/getOtp`;
  private validateOtpUrl = `${GlobalVariable.BASE_API_URL_SPARES}/insurancelogin/v2/validateOtp`;

  constructor(private http: HttpClient) { }

  sendOtp(mobile: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    });
    return this.http.post(this.sendOtpUrl, { mobile }, { headers });
  }

  validateOtp(mobile: string, otp: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=UTF-8'
    });
    return this.http.post(this.validateOtpUrl, { mobile, otp }, { headers });
  }
}
